<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Payment Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Payment Report",
      items: [
        {
          text: "Account Section",
          href: "#/",
        },
        {
          text: "Payment Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "patient_name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "patient_contact",
          sortable: true,
          label: "CONTACT",
        },

        {
          key: "filter_date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "total_cost",
          sortable: true,
          label: "TOTAL AMOUNT",
        },
        {
          key: "amount",
          sortable: true,
          label: "PAID AMOUNT",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "currency",
          sortable: true,
          label: "Currency",
        },
      ],
      fitered_array: [],
      filterreport: {
        py_type: "",
        title: "PAYMENT REPORT",
        today: moment(new Date()).format("YYYY-MM-DD"),
        date1: moment(new Date()).format("YYYY-MM-DD"),
        date2: moment(new Date()).format("YYYY-MM-DD"),
      },
      // FILTER

      rep_totals: {
        totalcost: 0,
        totalpaid: 0,
        totalbal: 0,
      },

      //   ============================= EXPORT ==============================
      json_fields: {
        Name: "patient_name",
        CONTACT: "patient_contact",
        DATE: "filter_date",
        TOTAL_AMOUNT: "total_cost",
        PAID_AMOUNT: "amount",
        BALANCE: "balance",
        CURRENCY: "currency",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    ...mapState("reports", ["daily_pay_report"]),
    ...mapGetters("reports", ["DailyPayReport"]),
    ...mapGetters("payments", ["DailyPatientReport"]),
    ...mapGetters("insurance", ["PaymentType"]),

    rows() {
      return this.fitered_array ? this.fitered_array.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.fitered_array ? this.fitered_array.length : 1;
  },
  watch: {
    daily_pay_report(newValue) {
      if (newValue.length > 0) {
        this.payment_reportData();
      }
    },
  },
  methods: {
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    payment_reportData() {
      this.fitered_array = this.DailyPayReport;

      return this.filter_report();
    },
    filter_report() {
      let ttpaid = 0;
      let ttbal = 0;
      let ttcost = 0;

      this.fitered_array = this.DailyPayReport.filter((element) => {
        if (
          this.filterreport.date1 != "" &&
          this.filterreport.date2 != "" &&
          this.filterreport.py_type == ""
        ) {
          if (
            element.date >= this.filterreport.date1 &&
            element.date <= this.filterreport.date2
          ) {
            let total_cost = element.ftotal_cost;
            ttcost = parseInt(total_cost) + ttcost;

            let tamount = element.famount;
            ttpaid = parseInt(tamount) + ttpaid;

            let fbalance = element.fbalance;
            ttbal = parseInt(fbalance) + ttbal;
          }

          // alert(element.date + "-" + this.filterreport.date1);
          return (
            element.date >= this.filterreport.date1 &&
            element.date <= this.filterreport.date2
          );
        } else if (
          element.date >= this.filterreport.date1 &&
          element.date <= this.filterreport.date2 &&
          this.filterreport.py_type != 0
        ) {
          if (
            element.date >= this.filterreport.date1 &&
            element.date <= this.filterreport.date2 &&
            element.pay_type == this.filterreport.py_type
          ) {
            let total_cost = element.ftotal_cost;
            ttcost = parseInt(total_cost) + ttcost;

            let tamount = element.famount;
            ttpaid = tamount + ttpaid;

            let fbalance = element.fbalance;
            ttbal = fbalance + ttbal;
          }

          return (
            element.date >= this.filterreport.date1 &&
            element.date <= this.filterreport.date2 &&
            element.pay_type == this.filterreport.py_type
          );
        }
      });

      this.rep_totals.totalpaid = this.thousandSeprator(ttpaid);
      this.rep_totals.totalbal = this.thousandSeprator(ttbal);
      this.rep_totals.totalcost = this.thousandSeprator(ttcost);
    },

    ...mapActions({
      FetchDailyPayReport: "reports/fetchDailyPayReport",
    }),

    localizeDate(date) {
      if (!date || !date.includes("-")) return date;
      const [yyyy, mm, dd] = date.split("-");
      return new Date(`${mm}/${dd}/${yyyy}`);
    },

    addComma() {
      this.discount.amount = this.thousandSeprator(this.discount.amount);
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  created() {
    this.payment_reportData();
    this.FetchDailyPayReport();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h3 class="card-title mb-2 text-center" v-html="filterreport.title"></h3>
            <div class="row">
              <div class="col-md-4 form-group">
                <label>FROM</label>
                <input
                  @change="filter_report()"
                  v-model="filterreport.date1"
                  type="date"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>TO</label>
                <input
                  @change="filter_report()"
                  v-model="filterreport.date2"
                  type="date"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>PAYMENT TYPE</label>
                <select
                  class="form-control"
                  v-model="filterreport.py_type"
                  @change="filter_report()"
                >
                  <option value="">All</option>
                  <option v-for="(ty, index) in PaymentType" :key="index" :value="ty.id">
                    {{ ty.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <download-excel
                  class="btn btn-primary mb-1"
                  :data="fitered_array"
                  :fields="json_fields"
                  :worksheet="'PAYMENT REPORT FOR' + currentdate"
                  type="csv"
                  :name="'payment_report_' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>

                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->

            <div class="table-responsive mb-0">
              <b-table
                foot-clone
                class="datatables"
                :items="fitered_array ? fitered_array : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(patient_name)="data">
                  {{ data.item.patient_name }}
                  <span
                    v-if="data.item.pay_type == 1"
                    class="badge rounded-pill bg-primary"
                    >Insurace</span
                  >
                  <span class="badge rounded-pill bg-success" v-else>personal</span>
                </template>

                <template #cell(actions)="data">
                  <button @clinc="yes(data)" class="btn btn-primary btn-sm">
                    Details
                  </button>
                </template>
                <template #cell(amount)="data">
                  {{ data.item.amount }}
                  <span
                    class="badge rounded-pill bg-info"
                    v-if="data.item.modeflag == 'C'"
                    >C</span
                  >
                  <span class="badge rounded-pill bg-warning" v-else>E</span>
                </template>
                <template #foot(patient_name)="">
                  <span class="text-danger"></span
                ></template>
                <template #foot(entered)=""> <span class="text-danger"></span></template>
                <template #foot(patient_contact)="">
                  <span class="text-danger"></span
                ></template>
                <template #foot(total_cost)="">
                  Total
                  <span class="text-primary"> {{ rep_totals.totalcost }}</span>
                </template>
                <template #foot(amount)="">
                  paid
                  <span class="text-primary">
                    {{ rep_totals.totalpaid }}
                  </span>
                </template>
                <template #foot(balance)="">
                  balance
                  <span class="text-danger">{{ rep_totals.totalbal }}</span>
                </template>
                <template #foot(index)=""> <span></span></template>
              </b-table>
              <center>
                <h3 v-if="!DailyPayReport" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
